import React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { Spin } from "antd";
import { ICaseLawDocumentUpdatingPresenter } from "../../presenter/CaseLawDocumentUpdatingPresenter";
import CaseLawDocumentUpdateForm from "../components/CaseLawDocumentUpdatingForm";

export interface Props extends PageProps {}

export interface State extends ICaseLawDocumentUpdatingPresenter {}
export default class CaseLawDocumentUpdatingPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props, current: 0 };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }
  render() {
    const {
      translate,
      caseLawDocument,
      caseLawDocumentTypes,
      organisations,
      attachmentTypes,
      attachmentContentTypes,
      caseLawDocumentAttachments,
      createAttachment,
      setFileValue,
      uploadedFile,
      updateAttachment,
      removeAttachment,
      indexHierarchyList,
      publishCaseLawDocument,
      revertCaseLawDocumentStatus,
      setOrganisationId,
      removeConnectedCourtCase,
      createConnectedCourtCase,
      organisationIndexes,
      connectedCourtCasesList,
      selectedCourtCases,
      selectedIndex,
      organisationCaseLawDocumentTypeId,
      nonAnonymisedAttachmentsCount,
      updateCaseLawDocument,
      showCaseLawDocumentDetails,
      parentGroupList,
      secondGroupList,
      selectedParentGroupIdList,
      selectedSecondGroupIdList,
      setParentGroupId,
      setSecondGroupId,
      archiveCaseLawDocument,
      onSearch,
      setInvalidatePublishedCaseLawDocuments,
      publishedCaseLawDocuments,
      invalidatePublishedCaseLawDocsVisible,
      invalidatedCaseLawDocuments,
      store,
      selectedOrganisationId,
      courtCaseConnectionTypeList,
      updateCourtCaseSelection,
      courtCaseSelectionResult,
      createCourtCasePopupVisible,
      createCourtCaseModalVisible,
      showCreateCourtCasePopupVisible,
      showCreateCourtCaseModalVisible,
      createCourtCase,
      nonExistantCourtCaseNumber,
      createCourtCaseAttachment,
      uploadedCourtCaseAttachment,
      findCourtCaseDetails,
      anonimisedUploadedFile,
      setAnonymisedFileValue,
      canEdit,
      courtCaseTypes,
      decisionTypes,
      indexTypeAttributes,
      setAttributesData,
      indexAttributeDataList,
      closeIndexDataModal,
      openIndexDataModal,
      indexDataModalVisible,
      saveAttributeData,
      selectedIndexForAttribute,
      onSelectConnectedCourtCaseDecision,
      selectedCaseDecisions
    } = this.state;
    return (
      <Page {...this.props} className={"page-wrapper"}>
        <Spin spinning={this.state.loaders.caseLawDocumentLoader}>
          <CaseLawDocumentUpdateForm
            translate={translate}
            caseLawDocument={caseLawDocument}
            caseLawDocumentTypes={caseLawDocumentTypes}
            organisations={organisations}
            attachmentTypes={attachmentTypes}
            attachmentContentTypes={attachmentContentTypes}
            caseLawDocumentAttachments={caseLawDocumentAttachments}
            createAttachment={createAttachment}
            setFileValue={setFileValue}
            uploadedFile={uploadedFile}
            updateAttachment={updateAttachment}
            removeAttachment={removeAttachment}
            indexHierarchyList={indexHierarchyList}
            publishCaseLawDocument={publishCaseLawDocument}
            revertCaseLawDocumentStatus={revertCaseLawDocumentStatus}
            setOrganisationId={setOrganisationId}
            removeConnectedCourtCase={removeConnectedCourtCase}
            createConnectedCourtCase={createConnectedCourtCase}
            createCourtCase={createCourtCase}
            organisationIndexes={organisationIndexes}
            connectedCourtCasesList={connectedCourtCasesList}
            selectedCourtCases={selectedCourtCases}
            selectedIndex={selectedIndex}
            organisationCaseLawDocumentTypeId={
              organisationCaseLawDocumentTypeId
            }
            nonAnonymisedAttachmentsCount={nonAnonymisedAttachmentsCount}
            onSubmit={updateCaseLawDocument}
            showCaseLawDocumentDetails={showCaseLawDocumentDetails}
            parentGroupList={parentGroupList}
            secondGroupList={secondGroupList}
            selectedParentGroupIdList={selectedParentGroupIdList}
            selectedSecondGroupIdList={selectedSecondGroupIdList}
            setParentGroupId={setParentGroupId}
            setSecondGroupId={setSecondGroupId}
            attachmentLoader={this.state.loaders.attachmentsLoader}
            archiveCaseLawDocument={archiveCaseLawDocument}
            onSearch={onSearch}
            setInvalidatePublishedCaseLawDocuments={
              setInvalidatePublishedCaseLawDocuments
            }
            publishedCaseLawDocuments={publishedCaseLawDocuments}
            invalidatePublishedCaseLawDocsVisible={
              invalidatePublishedCaseLawDocsVisible
            }
            invalidatedCaseLawDocuments={invalidatedCaseLawDocuments}
            store={store}
            selectedOrganisationId={selectedOrganisationId}
            courtCaseConnectionTypeList={courtCaseConnectionTypeList}
            updateCourtCaseSelection={updateCourtCaseSelection}
            courtCaseSelectionResult={courtCaseSelectionResult}
            createCourtCasePopupVisible={createCourtCasePopupVisible}
            createCourtCaseModalVisible={createCourtCaseModalVisible}
            showCreateCourtCasePopupVisible={showCreateCourtCasePopupVisible}
            showCreateCourtCaseModalVisible={showCreateCourtCaseModalVisible}
            nonExistantCourtCaseNumber={nonExistantCourtCaseNumber}
            createCourtCaseAttachment={createCourtCaseAttachment}
            findCourtCaseDetails={findCourtCaseDetails}
            uploadedCourtCaseAttachment={uploadedCourtCaseAttachment}
            anonimisedUploadedFile={anonimisedUploadedFile}
            setAnonymisedFileValue={setAnonymisedFileValue}
            canEdit={canEdit}
            courtCaseTypes={courtCaseTypes}
            decisionTypes={decisionTypes}
            indexTypeAttributes={indexTypeAttributes}
            setAttributesData={setAttributesData}
            indexAttributeDataList={indexAttributeDataList}
            closeIndexDataModal={closeIndexDataModal}
            openIndexDataModal={openIndexDataModal}
            indexDataModalVisible={indexDataModalVisible}
            saveAttributeData={saveAttributeData}
            selectedIndexForAttribute={selectedIndexForAttribute}
            onSelectConnectedCourtCaseDecision={
              onSelectConnectedCourtCaseDecision
            }
            selectedCaseDecision={
              courtCaseSelectionResult
                ? selectedCaseDecisions?.[
                    courtCaseSelectionResult.courtCaseNumber
                  ]
                : undefined
            }
          />
        </Spin>
      </Page>
    );
  }
}
